module.exports = __webpack_public_path__ + "img/lock-keyhole-circle.4a558de5.svg";